/**
 * 用户设置 API 路径
 */
export const USER_SETTINGS_API_PATHS = {
    /** 当前用户设置 */
    ROOT: '/user-settings',
} as const;

